import React from 'react';
import './UKUniversities.css';
const universities = {
  A: [
    "University of Aberdeen",
    "Abertay University (Dundee)",
    "Aberystwyth University",
    "Anglia Ruskin University",
    "Arden University (private)",
  ],
  B: [
    "Aston University (Birmingham)",
    "Bangor University",
    "University of Bath",
    "Bath Spa University",
    "University of Bedfordshire",
    "University of Birmingham",
    "Birmingham City University",
    "Birmingham Newman University",
    "University College Birmingham",
    "University of Bolton",
    "University of Bradford",
    "University of Brighton",
    "University of Bristol",
    "Brunel University London",
    "Buckinghamshire New University",
    "University of Buckingham (private)",
  ],
  C: [
    "Canterbury Christ Church University",
    "Cardiff University",
    "Cardiff Metropolitan University",
    "University of Central Lancashire",
    "University of Chester",
    "University of Chichester",
    "City, University of London",
    "Coventry University",
    "Cranfield University",
  ],
  D: [
    "De Montfort University",
    "University of Derby",
    "University of Dundee",
    "Durham University",
  ],
  E: [
    "University of East Anglia",
    "University of East London",
    "University of Edinburgh",
    "Edinburgh Napier University",
    "University of Essex",
    "University of Exeter",
  ],
  G: [
    "University of Glasgow",
    "Glasgow Caledonian University",
    "Glasgow School of Art",
    "University of Gloucestershire",
    "University of Greenwich",
    "Guildhall School of Music & Drama",
  ],
  H: [
    "Harper Adams University",
    "Heriot-Watt University",
    "University of Hertfordshire",
    "University of Huddersfield",
  ],
  "K–L": [
    "Keele University",
    "University of Kent",
    "Kingston University",
    "University of Lancaster",
    "University of Leeds",
    "Leeds Beckett University",
    "University of Leicester",
    "University of Lincoln",
    "University of Liverpool",
    "Liverpool Hope University",
    "Liverpool John Moores University",
    "London Business School",
    "University of London (federation)",
    "Queen Mary, University of London",
    "Royal Holloway, University of London",
    "SOAS, University of London",
    "St George’s, University of London",
    "Goldsmiths, University of London",
    "City, UCL, LSE, Imperial College",
    "London Metropolitan University",
    "London South Bank University",
    "University of the Arts London (Camberwell, Central Saint Martins, Chelsea, LCC, LCF, Wimbledon)",
    "Loughborough University",
  ],
  "M–N": [
    "Manchester Metropolitan University",
    "University of Manchester",
    "Middlesex University",
    "Newcastle University",
    "Northumbria University",
    "University of Northampton",
    "University of Nottingham",
    "Nottingham Trent University",
  ],
  "O–P": [
    "University of Oxford",
    "Oxford Brookes University",
    "University of Plymouth",
    "Plymouth Marjon University",
  ],
  Q: [
    "Queen’s University Belfast",
    "Queen Margaret University (Edinburgh)",
  ],
  R: [
    "University of Reading",
    "University of Roehampton",
    "University of Salford",
    "University of Sheffield",
    "Sheffield Hallam University",
    "University of Southampton",
    "Southampton Solent University",
    "Staffordshire University",
  ],
  S: [
    "University of Stirling",
    "University of Strathclyde",
    "University of Sunderland",
    "University of Surrey",
    "University of Sussex",
    "Swansea University",
    "Teesside University",
  ],
  "T–U": [
    "University of the Highlands & Islands",
    "University of the West of England (Bristol)",
    "University of the West of Scotland",
    "University of West London",
    "University of Westminster",
    "University of Wolverhampton",
    "University of Worcester",
  ],
  Y: [
    "York St John University",
    "University of York",
  ]
};

const UKUniversities = () => {
  return (
     <div className="uk-container">
      <h2 className="uk-title">UK Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UKUniversities;
